import type { SagaMiddleware } from "redux-saga";
import { uhfSagas } from "@gamedev-web/gamedev-uhf";

import { appContextSagas } from "./appContextSagas";
import { authSagas } from "./authSagas";
import { navigationSagas } from "./navigationSagas";

export const runSagas = (middleware: SagaMiddleware) => {
  const sagas = [uhfSagas, navigationSagas, appContextSagas, authSagas];
  sagas.forEach(saga => {
    middleware.run(saga);
  });
};
